<template>
  <div>
    <div v-if="$store.state.screenWidth>900">
      <div class="headerNav-height"></div>
      <div class="flexSpace headerNav">
        <div class="headerNav-left flexEnd">
          <router-link :to="'/'">
            <div class="flexCenter">
              <img src="https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/hospital-gw/logo%402x.png"
                   alt="" />
              <div class="headerNav-subTitle flexSpace">
                <div>
                  <div>湖南省互联网医院</div>
                  <div>中医特色的互联网医疗综合性服务平台</div>
                </div>
              </div>
            </div>
          </router-link>
        </div>
        <div class="headerNav-right flexStart">
          <div v-for="item in linkArr"
               :key="item.path">
            <div v-if="!item.notShow"
                 class="headerNav-link-item flexCenter">
              <!-- onLink.indexOf(item.path)>-1?'aB39162':'a333' -->
              <router-link :to="item.path"
                           :class="onLink(item)">{{item.label}}</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="headerNav-height"></div>
      <div class="flexSpace headerNav">
        <div class="headerNav-left flexEnd">
          <router-link :to="'/'">
            <div class="flexCenter">
              <img src="https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/hospital-gw/logo%402x.png"
                   alt="" />
              <div class="headerNav-subTitle flexSpace">
                <div>
                  <div>湖南省互联网医院</div>
                  <div>中医特色的互联网医疗综合性服务平台</div>
                </div>
              </div>
            </div>
          </router-link>
        </div>
        <div class="headerNav-right"
             @click="showLinkBanner = !showLinkBanner">
          <img :src="iconUrl"
               alt=""
               :class="showLinkBanner?'headerNav-right-img-on':'headerNav-right-img-off'">
        </div>
        <div v-if="showLinkBanner"
             class="headerNav-link">
          <div v-for="item in linkArr"
               :key="item.path">
            <div v-if="!item.notShow"
                 class="headerNav-link-item">
              <router-link :to="item.path"
                           :class="onLink(item)">{{item.label}}</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import linkArr from "../../router/home";

export default {
  data() {
    return {
      linkArr: linkArr,
      showLinkBanner: false,
    };
  },
  watch: {
    $route(to, form) {
      console.log(to, form, "routerouteroute");
    },
  },
  computed: {
    iconUrl() {
      if (this.showLinkBanner) {
        return "https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/hospital-gw/phoneh5/home/butdown%402x.png";
      } else {
        return "https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/hospital-gw/phoneh5/home/butup%402x.png";
      }
    },
  },
  mounted() {
    console.log(this.$route);
  },
  methods: {
    onLink(item) {
      const link = this.$route.path;
      const { path } = item;
      if (link === path || (path != "/" && link.indexOf(path) > -1)) {
        return "aB39162";
      }
      return "a333";
    },
  },
};
</script>

<style lang="less" scoped>
@import url("../../../static/css/fontSize.less");
@media screen and (max-width: 900px) {
  .headerNav-height,
  .headerNav {
    width: 100%;
    height: 110 * @width;
  }
  .headerNav {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
    background: #fff;
    .headerNav-left {
      padding-left: 20 * @width;
      .headerNav-subTitle::before {
        display: block;
        content: "";
        width: 1 * @width;
        height: 42 * @width;
        background: #999;
        margin-left: 15 * @width;
        margin-right: 23 * @width;
      }
      .headerNav-subTitle {
        line-height: 35 * @width;
        color: #999999;
        font-size: 15 * @width;
      }
      img {
        width: 177 * @width;
        height: 50 * @width;
      }
    }

    .headerNav-right {
      padding-right: 30 * @width;
      .headerNav-right-img-on {
        width: 30 * @width;
        height: 30 * @width;
      }
      .headerNav-right-img-off {
        width: 40 * @width;
        height: 29 * @width;
      }
    }
    .headerNav-link {
      position: absolute;
      top: 110 * @width;
      width: 100%;
      padding: 10 * @width 20 * @width;
      background: #ffffff;
      box-shadow: 0 5px 15px #efefef;
      .headerNav-link-item {
        width: 100%;
        line-height: 105 * @width;
        border-bottom: 2 * @width solid #efefef;
        font-size: 26 * @width;
      }
      .headerNav-link-item:last-child {
        border-bottom: 2 * @width solid #fff;
      }
    }
  }
}
@media screen and (min-width: 900px) {
  .headerNav-height,
  .headerNav {
    width: 100%;
    min-width: 1200px;
    height: 90px;
  }
  .headerNav {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
    background: #fff;
    .headerNav-left,
    .headerNav-right {
      width: 50%;
    }
    .headerNav-left {
      padding-right: 170px;
      .headerNav-subTitle::before {
        display: block;
        content: "";
        width: 1px;
        height: 16px;
        background: #999;
        margin-left: 8px;
        margin-right: 13px;
      }
      .headerNav-subTitle {
        line-height: 20px;
        color: #999999;
        font-size: 12px;
      }
      img {
        width: 138px;
        height: 38px;
      }
    }

    .headerNav-right {
      padding-left: 30px;
      .headerNav-link-item {
        width: 160px;
        font-size: 16px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/headerNav/headerNav.vue